import { useIdleTimer } from 'react-idle-timer'

interface UseIdleTimeoutParams {
  onIdle: (e: Event) => void
}

export const useIdleTimeout = ({ onIdle }: UseIdleTimeoutParams) => {
  useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * 60 * 2,
  })
}
